import {combineReducers} from 'redux'
import {get, isNil, mapValues} from 'lodash'
import types from 'actions/types'
import {
  mergeLeadsOpportunities,
  removeFromLeadsOpportunities,
  sortLeadsOpportunityList,
  updateLeadsCounts,
  updateLeadsOpportunities,
  updateLeadsValues,
} from 'helpers/opportunities'

export const jobTypes = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_LEADS_FILTERS:
      return get(action, 'filters.jobTypes', state)
    default:
      return state
  }
}

export const company = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_LEADS_FILTERS:
      return get(action, 'filters.company', state)
    default:
      return state
  }
}

export const createdStart = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_LEADS_FILTERS:
      return get(action, 'filters.createdStart', state)
    default:
      return state
  }
}

export const createdEnd = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_LEADS_FILTERS:
      return get(action, 'filters.createdEnd', state)
    default:
      return state
  }
}

export const createdTimeKey = (state = null, action) => {
  switch (action.type) {
    case types.SALES_UPDATE_LEADS_FILTERS:
      return get(action, 'filters.createdTimeKey', state)
    default:
      return state
  }
}

export const search = (state = '', action) => {
  switch (action.type) {
    case types.SALES_SEARCH_LEADS_OPPORTUNITIES:
      return action.search
    default:
      return state
  }
}

export const opportunities = (state = {}, action) => {
  switch (action.type) {
    case types.SALES_LOAD_LEADS_OPPORTUNITIES_ATTEMPT:
      return action.page !== 0
          ? state
          : {
            ...state,
            [action.ownerId || 0]: [],
          }

    case types.SALES_LOAD_LEADS_OPPORTUNITIES_SUCCESS:
      return action.page > 0
          ? mergeLeadsOpportunities(state, action.data)
          : {
            ...state,
            [action.ownerId || 0]: sortLeadsOpportunityList(action.data),
          }

    case types.SALES_UPDATE_LEADS_OPPORTUNITY:
      return !isNil(action.updatedOpportunity)
          ? updateLeadsOpportunities(state, action.updatedOpportunity)
          : removeFromLeadsOpportunities(state, action.previousOpportunity.id)

    default:
      return state
  }
}

export const pages = (state = {}, action) => {
  switch (action.type) {
    case types.SALES_LOAD_ALL_LEADS_OPPORTUNITIES:
      return mapValues(state, () => 0)

    case types.SALES_LOAD_LEADS_OPPORTUNITIES_ATTEMPT:
      return {
        ...state,
        [action.ownerId || 0]: isNil(action.page) ? 0 : action.page,
      }

    default:
      return state
  }
}

export const counts = (state = {}, action) => {
  switch (action.type) {

    case types.SALES_LOAD_LEADS_OPPORTUNITIES_ATTEMPT:
      return action.page > 0
          ? state
          : {
            ...state,
            [action.ownerId || 0]: null,
          }

    case types.SALES_LOAD_LEADS_OPPORTUNITIES_SUCCESS:
      return isNil(action.count)
          ? state
          : {
            ...state,
            [action.ownerId || 0]: action.count,
          }

    case types.SALES_UPDATE_LEADS_OPPORTUNITY:
      return updateLeadsCounts(state, action.previousOpportunity, action.updatedOpportunity)

    default:
      return state
  }
}

export const values = (state = {}, action) => {
  switch (action.type) {

    case types.SALES_LOAD_LEADS_OPPORTUNITIES_ATTEMPT:
      return action.page > 0
          ? state
          : {
            ...state,
            [action.ownerId || 0]: null,
          }

    case types.SALES_LOAD_LEADS_OPPORTUNITIES_SUCCESS:
      return isNil(action.value)
          ? state
          : {
            ...state,
            [action.ownerId || 0]: action.value,
          }

    case types.SALES_UPDATE_LEADS_OPPORTUNITY:
      return updateLeadsValues(state, action.previousOpportunity, action.updatedOpportunity)

    default:
      return state
  }
}

export const loading = (state = {}, action) => {
  switch (action.type) {

    case types.SALES_LOAD_LEADS_OPPORTUNITIES_ATTEMPT:
      return {
        ...state,
        [action.ownerId || 0]: true,
      }

    case types.SALES_LOAD_LEADS_OPPORTUNITIES_SUCCESS:
      return {
        ...state,
        [action.ownerId || 0]: false,
      }

    case types.SALES_LOAD_LEADS_OPPORTUNITIES_FAILURE:
      return {
        ...state,
        [action.ownerId || 0]: false,
      }

    default:
      return state
  }
}

export default combineReducers({
  opportunities,
  loading,
  pages,
  counts,
  values,
  search,
  jobTypes,
  company,
  createdStart,
  createdEnd,
  createdTimeKey,
})
